<script type="text/jsx">
import { getCell, getColumnByCell, getRowIdentity } from './util'
import { PREFIX_CLASS } from '../../utils/constants'
import { hasClass } from '@/utils/helper'
import LayoutObserver from './layout-observer'
import Tooltip from '@/module/tooltip/constructor'
const PREFIX_TABLE_CLASS = `${PREFIX_CLASS}table`
export default {
  name: 'TableBody',
  mixins: [LayoutObserver],
  props: {
    store: {
      required: true,
      type: Object
    },
    stripe: Boolean,
    context: {
      type: Object,
      default() {
        return {}
      }
    },
    rowClassName: {
      type: [String, Function],
      default: ''
    },
    rowStyle: {
      type: [Object, Function],
      default() {
        return {}
      }
    },
    fixed: String,
    highlight: Boolean
  },

  data() {
    return {
      TooltipTool: null,
      prefixClass: PREFIX_TABLE_CLASS,
      tooltip: {
        content: ''
      }
    }
  },
  computed: {
    table() {
      return this.$parent
    },

    data() {
      return this.store.states.data
    },

    treeData() {
      return this.store.states.treeData
    },

    columnsCount() {
      return this.store.states.columns.length
    },

    leftFixedLeafCount() {
      return this.store.states.fixedLeafColumnsLength
    },

    rightFixedLeafCount() {
      return this.store.states.rightFixedLeafColumnsLength
    },

    leftFixedCount() {
      return this.store.states.fixedColumns.length
    },

    rightFixedCount() {
      return this.store.states.rightFixedColumns.length
    },

    columns() {
      return this.store.states.columns
    },

    hasExpandColumn() {
      return this.columns.some(({ type }) => type === 'expand')
    },

    firstDefaultColumnIndex() {
      for (let index = 0; index < this.columns.length; index++) {
        if (this.columns[index].type === 'default') {
          return index
        }
      }
      return 0
    },

    treeIndent() {
      return this.store.states.indent
    },
    columnsHidden() {
      return this.columns.map((column, index) => this.$_isColumnHidden(index))
    },
    rows() {
      let rows = this.data
      if (this.store.states.lazy && Object.keys(this.store.states.lazyTreeNodeMap).length) {
        rows = rows.reduce((prev, item) => {
          prev.push(item)
          const rowKey = this.store.table.getRowKey(item)
          const parent = this.store.states.treeData[rowKey]
          if (parent && parent.children && parent.hasChildren) {
            const tmp = []
            const traverse = (children) => {
              if (!children) return
              children.forEach(key => {
                tmp.push(this.store.states.lazyTreeNodeMap[key])
                if (this.store.states.treeData[key]) {
                  traverse(this.store.states.treeData[key].children)
                }
              })
            }
            traverse(parent.children)
            prev = prev.concat(tmp)
          }
          return prev
        }, [])
      }
      return rows
    }
  },
  created() {
    // this.activateTooltip = debounce(50, tooltip => tooltip.handleShowPopper())
    this.TooltipTool = new Tooltip(this.tooltip)
  },
  beforeDestroy() {
    this.$_destoryTooltip()
  },
  methods: {
    $_createTooltip(el, content) {
      this.tooltip.content = content
      if (this.TooltipTool && this.TooltipTool.popperJS) {
        this.$_destoryTooltip()
      }
      this.TooltipTool.createTooltip(this.tooltip, el)
      this.$nextTick(() => {
        this.TooltipTool.updateState({
          value: this.tooltip
        }, el)
        this.TooltipTool.onHandleTooltip(el, true)
      })
      // setTimeout(() => {
      //   this.TooltipTool.updateState({
      //     value: this.tooltip
      //   }, el)
      //   this.TooltipTool.onHandleTooltip(el, true)
      // }, 100)
    },
    $_destoryTooltip() {
      if (this.TooltipTool) {
        this.TooltipTool.destoryPopper()
      }
    },
    $_getKeyOfRow(row, index) {
      const rowKey = this.table.rowKey
      if (rowKey) {
        return getRowIdentity(row, rowKey)
      }
      return index
    },

    $_isColumnHidden(index) {
      if (this.fixed === true || this.fixed === 'left') {
        return index >= this.leftFixedLeafCount
      } else if (this.fixed === 'right') {
        return index < this.columnsCount - this.rightFixedLeafCount
      } else {
        return (index < this.leftFixedLeafCount) || (index >= this.columnsCount - this.rightFixedLeafCount)
      }
    },

    $_getSpan(row, column, rowIndex, columnIndex) {
      let rowspan = 1
      let colspan = 1

      const fn = this.table.spanMethod
      if (typeof fn === 'function') {
        const result = fn({
          row,
          column,
          rowIndex,
          columnIndex
        })

        if (Array.isArray(result)) {
          rowspan = result[0]
          colspan = result[1]
        } else if (typeof result === 'object') {
          rowspan = result.rowspan
          colspan = result.colspan
        }
      }

      return {
        rowspan,
        colspan
      }
    },

    $_getRowStyle(row, rowIndex) {
      const rowStyle = this.table.rowStyle
      if (typeof rowStyle === 'function') {
        return rowStyle.call(null, {
          row,
          rowIndex
        })
      }
      return rowStyle
    },

    $_getRowClass(row, rowIndex) {
      const classes = ['table__row']
      if (this.table.highlightCurrentRow && row === this.store.states.currentRow) {
        classes.push('current-row')
      }

      if (rowIndex === this.store.states.hoverRow) {
        classes.push('hover-row')
      }

      if (this.stripe && rowIndex % 2 === 1) {
        classes.push('table__row--striped')
      }
      const rowClassName = this.table.rowClassName
      if (typeof rowClassName === 'string') {
        classes.push(rowClassName)
      } else if (typeof rowClassName === 'function') {
        classes.push(rowClassName.call(null, {
          row,
          rowIndex
        }))
      }

      if (this.store.states.expandRows.indexOf(row) > -1) {
        classes.push('expanded')
      }
      const rowKey = this.table.rowKey ? this.$_getKeyOfRow(row, rowIndex) : `r${rowIndex}`
      if (rowKey && this.treeData[rowKey]) {
        classes.push(PREFIX_TABLE_CLASS + '__row--level-' + this.treeData[rowKey].level)
      }
      return classes
    },

    $_getCellStyle(rowIndex, columnIndex, row, column) {
      const cellStyle = this.table.cellStyle
      if (typeof cellStyle === 'function') {
        return cellStyle.call(null, {
          rowIndex,
          columnIndex,
          row,
          column
        })
      }
      return cellStyle
    },

    $_getCellClass(rowIndex, columnIndex, row, column) {
      const classes = [column.id, column.align || '', column.className || '']

      if (this.$_isColumnHidden(columnIndex)) {
        classes.push('is-hidden')
      }

      const cellClassName = this.table.cellClassName
      if (typeof cellClassName === 'string') {
        classes.push(cellClassName)
      } else if (typeof cellClassName === 'function') {
        classes.push(cellClassName.call(null, {
          rowIndex,
          columnIndex,
          row,
          column
        }))
      }

      return classes.join(' ')
    },

    $_handleCellMouseEnter(event, row, column) {
      const table = this.table
      const cell = getCell(event)

      if (cell) {
        const column = getColumnByCell(table, cell)
        const hoverState = table.hoverState = { cell, column, row }
        table.$emit('cell-mouse-enter', hoverState.row, hoverState.column, hoverState.cell, event)
      }

      // 判断是否text-overflow, 如果是就显示tooltip
      const cellChild = event.target.querySelector('.cell')
      if (!(hasClass(cellChild, 'cell--ellipsis') && cellChild.childNodes.length)) {
        // use range width instead of scrollWidth to determine whether the text is overflowing
        return
      }
      const isEllipse = this.$_isEllipsis(cellChild)
      if (isEllipse || column.showOverflowTooltip) {
        const content = cell.innerText || cell.textContent
        this.$_createTooltip(cell, content)
      }
    },
    $_isEllipsis ($target) {
      if ($target && $target.offsetWidth < $target.scrollWidth) { // 判断是否有文字缩略
        return true
      } else {
        return false
      }
    },
    $_handleCellMouseLeave(event) {
      this.$_destoryTooltip()
      const cell = getCell(event)
      if (!cell) return
      const oldHoverState = this.table.hoverState || {}
      this.table.$emit('cell-mouse-leave', oldHoverState.row, oldHoverState.column, oldHoverState.cell, event)
    },

    $_handleMouseEnter(index) {
      this.store.commit('setHoverRow', index)
    },

    $_handleMouseLeave() {
      this.store.commit('setHoverRow', null)
    },

    $_handleContextMenu(event, row) {
      this.$_handleEvent(event, row, 'contextmenu')
    },

    $_handleDoubleClick(event, row) {
      this.$_handleEvent(event, row, 'dblclick')
    },

    $_handleClick(event, row) {
      this.store.commit('setCurrentRow', row)
      this.$_handleEvent(event, row, 'click')
    },

    $_handleEvent(event, row, name) {
      const table = this.table
      const cell = getCell(event)
      let column
      if (cell) {
        column = getColumnByCell(table, cell)
        if (column) {
          table.$emit(`cell-${name}`, row, column, cell, event)
        }
      }
      table.$emit(`row-${name}`, row, column, event)
    },

    $_handleExpandClick(row, e) {
      e.stopPropagation()
      this.store.toggleRowExpansion(row)
    }
  },
  render(h) {
    const columnsHidden = this.columns.map((column, index) => this.$_isColumnHidden(index))
    let rows = this.data
    if (this.store.states.lazy && Object.keys(this.store.states.lazyTreeNodeMap).length) {
      rows = rows.reduce((prev, item) => {
        prev.push(item)
        const rowKey = this.store.table.getRowKey(item)
        const parent = this.store.states.treeData[rowKey]
        if (parent && parent.children && parent.hasChildren) {
          const tmp = []
          const traverse = (children) => {
            if (!children) return
            children.forEach(key => {
              tmp.push(this.store.states.lazyTreeNodeMap[key])
              if (this.store.states.treeData[key]) {
                traverse(this.store.states.treeData[key].children)
              }
            })
          }
          traverse(parent.children)
          prev = prev.concat(tmp)
        }
        return prev
      }, [])
    }
    const wrapper = (
      <table
        class={PREFIX_TABLE_CLASS + '__body'}
        cellspacing="0"
        cellpadding="0"
        border="0">
        <colgroup>
          {
            this._l(this.columns, column => <col name={ column.id } />)
          }
        </colgroup>
        <tbody>
          {
            this._l(rows, (row, $index) => {
              const rowKey = this.table.rowKey ? this.$_getKeyOfRow(row, $index) : $index
              const treeNode = this.treeData[rowKey]
              const rowClasses = this.$_getRowClass(row, $index)
              if (treeNode) {
                rowClasses.push(PREFIX_TABLE_CLASS + '__row--level-' + treeNode.level)
              }
              const tr = (<tr
                v-show={ treeNode ? treeNode.display : true }
                style={ this.rowStyle ? this.$_getRowStyle(row, $index) : null }
                key={ rowKey }
                on-dblclick={ ($event) => this.$_handleDoubleClick($event, row)}
                on-click={ ($event) => this.$_handleClick($event, row) }
                on-contextmenu={ ($event) => this.$_handleContextMenu($event, row) }
                on-mouseenter={ _ => this.$_handleMouseEnter($index) }
                on-mouseleave={ _ => this.$_handleMouseLeave() }
                class={ rowClasses }>
                {
                  this._l(this.columns, (column, cellIndex) => {
                    const { rowspan, colspan } = this.$_getSpan(row, column, $index, cellIndex)
                    if (!rowspan || !colspan) {
                      return ''
                    } else {
                      const data = {
                        store: this.store,
                        _self: this.context || this.table.$vnode.context,
                        row,
                        column,
                        $index
                      }
                      if (cellIndex === this.firstDefaultColumnIndex && treeNode) {
                        data.treeNode = {
                          hasChildren: treeNode.hasChildren || (treeNode.children && treeNode.children.length),
                          expanded: treeNode.expanded,
                          indent: treeNode.level * this.treeIndent,
                          level: treeNode.level,
                          loaded: treeNode.loaded,
                          rowKey
                        }
                      }
                      return (
                        <td
                          style={ this.$_getCellStyle($index, cellIndex, row, column) }
                          class={ this.$_getCellClass($index, cellIndex, row, column) }
                          rowspan={ rowspan }
                          colspan={ colspan }
                          on-mouseenter={ ($event) => this.$_handleCellMouseEnter($event, row, column) }
                          on-mouseleave={ this.$_handleCellMouseLeave }>
                          {
                            column.renderCell.call(
                              this._renderProxy,
                              h,
                              data,
                              columnsHidden[cellIndex]
                            )
                          }
                        </td>
                      )
                    }
                  })
                }
              </tr>)
              if (this.hasExpandColumn && this.store.isRowExpanded(row)) {
                return [
                  tr,
                  <tr>
                    <td colspan={ this.columns.length } class={PREFIX_TABLE_CLASS + '__expanded-cell'}>
                      { this.table.renderExpanded ? this.table.renderExpanded(h, { row, $index, store: this.store }) : ''}
                    </td>
                  </tr>
                ]
              } else {
                return tr
              }
            })
          }
        </tbody>
      </table>
    )
    return wrapper
  }
}
</script>



// WEBPACK FOOTER //
// src/module/table/table-body.vue